<template>
  <div id="app-container">
    <div id="content">
      <img alt="Vue logo" src="./assets/logo.png">
      <HelloWorld msg="Welcome to Your Vue.js App"/>
    </div>
    <footer id="footer">
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
        京ICP备2025112070号-1
      </a>
    </footer>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#app-container {
  min-height: 100vh;
  padding-bottom: 60px; /* 为固定底部留出空间 */
}

#content {
  flex: 1;
}

#footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #f5f5f5;
  padding: 20px;
  text-align: center;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

#footer a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

#footer a:hover {
  color: #42b983;
  text-decoration: underline;
}
</style>
